export default __webpack_public_path__ + "edd085adda298522d0aa2b3d51f061ef.png";